import { isValidElement, cloneElement, useState } from 'react';
import { IconBarChart, IconClipboard, IconTruck, IconCheckCircle, IconGRN, IconImage } from './sidebarIcons';
import { Building2, Gift, Undo2, NotebookPen } from 'lucide-react';
import Sidebar from '../components/SidebarNext';
import { hasFunctionAccess } from '../permissionConfig';

const NAV_BASE = [
    { to: '/po-so-lifecycle/supply-chain-dashboard', label: 'SCM Analytics Dashboard', icon: <IconBarChart />, functionKey: 'supply_chain_dashboard' },
    { to: '/po-so-lifecycle/po-tracker',      label: 'PO Tracker',     icon: <IconClipboard />,   functionKey: 'po_tracker' },
    { to: '/po-so-lifecycle/b2b-dispatch',    label: 'B2B Dispatch',   icon: <IconTruck />,        functionKey: 'b2b_dispatch' },
    { to: '/po-so-lifecycle/so-kam-review',   label: 'SO KAM Review',  icon: <IconCheckCircle />,  functionKey: 'so_kam_review' },
    { to: '/po-so-lifecycle/grn-management',  label: 'Goods Received Note', icon: <IconGRN />,      functionKey: 'grn_management' },
    { to: '/po-so-lifecycle/rtv-record',      label: 'RTV Record',     icon: <Undo2 size={18} />,  functionKey: 'rtv_record' },
    { to: '/po-so-lifecycle/box-images',      label: 'Packed Box Images', icon: <IconImage />,     functionKey: 'box_images' },
    { to: '/po-so-lifecycle/institutional-orders', label: 'Institutional Orders', icon: <Building2 size={18} />, functionKey: 'institutional_orders' },
    { to: '/po-so-lifecycle/gifting-dispatch', label: 'Gifting & Dispatch', icon: <Gift size={18} />, functionKey: 'gifting_dispatch' },
    { to: '/po-so-lifecycle/po-register-data', label: 'PO Register Data', icon: <NotebookPen size={18} />, functionKey: 'po_register_data' },
];

const THEME_KEY = 'poso_theme';
const THEME_OPTIONS = [
    { key: 'normal', label: 'Light' },
    { key: 'dark',   label: 'Dark' },
];

export default function POSOLifecycleLayout({ user, onLogout, children }) {
    const [theme, setTheme] = useState(() => localStorage.getItem(THEME_KEY) || 'normal');
    const changeTheme = (next) => {
        setTheme(next);
        localStorage.setItem(THEME_KEY, next);
    };

    const navItems = NAV_BASE.map(item => ({ ...item, locked: !hasFunctionAccess(user, 'po_so_lifecycle', item.functionKey) }));
    return (
        <div data-sbn-theme={theme === 'normal' ? undefined : theme}
             style={{ display: 'flex', height: '100vh', overflow: 'hidden', background: theme === 'dark' ? '#141220' : '#FAF8FC' }}>
            <Sidebar navItems={navItems} sectionLabel="PO & SO Lifecycle" homeHref="/landing" user={user}
                     domainKey="po_so_lifecycle"
                     theme={theme} onThemeChange={changeTheme} themeOptions={THEME_OPTIONS} />
            <div id="sbn-main" className="sbn-content"
                 style={{ flex: 1, minWidth: 0, padding: '28px 32px', overflowY: 'auto', height: '100%' }}>
                {isValidElement(children) ? cloneElement(children, { theme }) : children}
            </div>
        </div>
    );
}
